
export enum BeforeOrAfterTax {
  BeforeTax = 1,
  AfterTax
}
